"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countriesListIso2ToId = exports.countriesListIsoToFullName = exports.countriesListNameToIso2 = void 0;
exports.countriesListNameToIso2 = {
    '': '',
    'the united states of america': 'US',
    'united states of america': 'US',
    'united states': 'US',
    usa: 'US',
    us: 'US',
    'russian federation': 'RU'
};
exports.countriesListIsoToFullName = {
    us: 'United States of America',
    usa: 'United States of America'
};
exports.countriesListIso2ToId = {
    'US': 1
};
//# sourceMappingURL=countriesList.js.map